module.exports = __webpack_public_path__ + "static/media/Enmascarar grupo 237.ee6f18bb.svg";